<template>
	<v-row class="headerBlock"
		:style="'height: ' + headerHeight + 'px; padding-top: ' + headerPadding + 'px; background-color: ' + (bgcolor ?? 'var(--header-bg-color)') + '; border-bottom: ' + (border ?? '1') + 'px solid var(--header-border-color);' + (transparent ? 'background-color: transparent; border-bottom: none;' : '') ">
	<v-col class="left-col v-col-2">
		<div v-if="allowBack && !escapeRoute && !logicalBack" class="mg-circle-icon-button" @click="handleBack();">
			<img :src="require('@/assets/L-Arrow-24px.svg')" alt="Back" :class="['back-arrow-icon', { 'white-arrow': color === 'white' }]" />
		</div>
		<div v-if="allowBack && !escapeRoute && logicalBack" class="mg-circle-icon-button" @click="handleLogicalBack()">
			<img :src="require('@/assets/L-Arrow-24px.svg')" alt="Back" :class="['back-arrow-icon', { 'white-arrow': color === 'white' }]" />
		</div>
	</v-col>
		<v-col class="title" :style="'color: ' + (color ?? 'var(--header-text-color)')">{{ title }}
			<slot />
		</v-col>
		<v-col class="right-col v-col-2">
			<div class="right-col-icons" :class="{ 'single-icon': rightColIcons.length === 1 }">
				<template v-for="icon in rightColIcons" :key="icon.type">
					<!-- Notifications -->
					<div
						v-if="icon.type === 'notifications'"
						class="notification-bell-wrapper"
						@click="$router.push('/allnotifications')"
					>
						<img
							class="mg-circle-image-button"
							:src="require('@/assets/notificationbell.png')"
						/>
						<!-- <span v-if="notificationCount > 0" class="notification-badge">{{ notificationCount }}</span> -->
					</div>

					<!-- Settings -->
					<div
						v-else-if="icon.type === 'settings'"
						class="mg-circle-icon-button"
						@click="$router.push('/settings')"
					>
						<img :src="require('@/assets/settingscog.png')" alt="Settings" class="menu-icon" />
					</div>

					<!-- Chat -->
					<div v-else-if="icon.type === 'chat'" class="mg-chat-button">
						<ChatMgButton :prompt="icon.prompt" :hover="false" />
					</div>

					<!-- Favorites -->
					<img
						v-else-if="icon.type === 'favorites'"
						class="mg-circle-image-button favorites-icon"
						:src="require('@/assets/heart.png')"
						@click="$router.push('/FavoriteVouchers')"
					/>

					<!-- Voucher -->
					<img
						v-else-if="icon.type === 'voucher'"
						class="mg-circle-image-button"
						:src="require('@/assets/Wallet-24px.svg')"
						@click="$router.push('/Wallet')"
					/>

					<!-- Add -->
					<img
						v-else-if="icon.type === 'add'"
						class="mg-circle-image-button"
						:src="require('@/assets/plus-inverted.png')"
						@click="$router.push('/shopvouchers')"
					/>

					<!-- WhatsApp -->
					<img
						v-else-if="icon.type === 'whatsapp'"
						class="mg-circle-image-button"
						:src="require('@/assets/whatsappicon.png')"
						alt="WhatsApp"
						@click="$emit('whatsapp')"
					/>

					<!-- Close -->
					<div
						v-else-if="icon.type === 'close'"
						class="mg-circle-icon-button"
						@click="goEscape"
					>
						<img :src="require('@/assets/close-24px.svg')" alt="Close" class="close-icon" />
					</div>

					<!-- Edit -->
					<div
						v-else-if="icon.type === 'edit'"
						class="mg-circle-icon-button"
						@click="onEditPressed"
					>
						<v-icon icon="mdi-pencil" />
					</div>

					<!-- Delete -->
					<div
						v-else-if="icon.type === 'delete'"
						class="mg-circle-icon-button"
						@click="showDelete = true"
					>
						<v-icon icon="mdi-delete" />
					</div>

					<!-- Edit + Delete Menu -->
					<div
						v-else-if="icon.type === 'menu-edit-delete'"
						class="mg-circle-icon-button"
						@click="showEditDeleteMenu = true"
					>
						<img :src="require('@/assets/Menu.png')" alt="Menu" class="menu-icon" />
					</div>
				</template>
			</div>
		</v-col>
	</v-row>

	<MGDialog v-model="showEditDeleteMenu" :title="menuTitle" maxWidth="500px" contentHeight="auto">
		<template #actions>
			<p>{{ menuDescription }}</p>
			<template v-if="!deleteOnly">
				<MGButton :fullWidth="true" @click="showEditDeleteMenu = false; onEditPressed()" :text="menuEditLabel" />
			</template>
			<MGButton :stacked="deleteOnly ? false : true" :fullWidth="true" @click="showEditDeleteMenu = false; showDelete = true" :text="menuDeleteLabel" />
			<MGButton :stacked="true" :fullWidth="true" @click="showEditDeleteMenu = false" :outline="true" text="Cancel" />
		</template>
	</MGDialog>

	<MGDialog v-model="showDelete" title="Delete" maxWidth="500px" contentHeight="auto">
		<template #content>
			<p>Are you sure you want to delete "{{ title }}"?</p>
		</template>
		<template #actions>
			<MGButton :fullWidth="true" @click="handleDelete" :text="deleting ? 'Deleting...' : 'Delete'" :disabled="deleting" />
			<MGButton :stacked="true" :fullWidth="true" @click="showDelete = false" :outline="true" text="Cancel" :disabled="deleting" />
		</template>
	</MGDialog>

</template>

<script>
import ChatMgButton from './ChatMgButton.vue';
import MGButton from './MGButton.vue';
import MGDialog from './MGDialog.vue';
export default {
	name: "HeaderBlock",
	props: {
		title: { type: String, required: true },
		color: { type: String, default: null },
		bgcolor: { type: String, default: null },
		border: { type: String, default: "1" },
		edit: { type: Boolean, default: false },
		del: { type: Boolean, default: false },
		deleteOnly: { type: Boolean, default: false },
		menuTitle: { type: String, default: 'Options' },
		menuDescription: { type: String, default: '' },
		menuEditLabel: { type: String, default: 'Edit' },
		menuDeleteLabel: { type: String, default: 'Delete' },
		logicalBack: { type: Boolean, default: false },
		transparent: { type: Boolean, default: false },
		colourMode: { type: String, default: null },
		notificationCount: { type: Number, default: 0 }
	},
	emits: ['delete', 'edit', 'back', 'logicalBack', 'whatsapp'],
	components: { ChatMgButton, MGButton, MGDialog },
	data() {
		return {
			escapeRoute: null,
			allowBack: false,
			showDelete: false,
			showEditDeleteMenu: false,
			deleting: false,
			favoritesIcon: false,
			mgChat: false,
			settingsMenu: false,
			voucherIcon: false,
			whatsappIcon: false,
			addButton: false,
			notificationsIcon: false
		}
	},
	computed: {
		safeTop() {
			return parseInt(this.$cookies.get('st') ?? 0);
		},
		headerHeight() {
			return 56 + this.safeTop;
		},
		headerPadding() {
			return 4 + this.safeTop;
		},
		rightColIcons() {
			const icons = [];

			if (this.notificationsIcon) {
				icons.push({ type: 'notifications' });
			}

			if (this.settingsMenu) {
				icons.push({ type: 'settings' });
			}

			if (this.favoritesIcon) {
				icons.push({ type: 'favorites' });
			}

			if (this.voucherIcon) {
				icons.push({ type: 'voucher' });
			}

			if (this.addButton) {
				icons.push({ type: 'add' });
			}

			if (this.whatsappIcon) {
				icons.push({ type: 'whatsapp' });
			}

			if (this.escapeRoute && !this.$route.query.inModal) {
				icons.push({ type: 'close' });
			}

			if (this.edit && this.del) {
				icons.push({ type: 'menu-edit-delete' });
			} else if (this.edit) {
				icons.push({ type: 'edit' });
			} else if (this.del) {
				icons.push({ type: 'delete' });
			}

			if (this.mgChat && !this.escapeRoute) {
				icons.push({ type: 'chat', prompt: this.mgChat });
			}

			return icons;
		}
	},
	methods: {
		onLoad() {
			this.settingsMenu = this.$route.meta.showSettings;
			this.voucherIcon = this.$route.meta.showVoucherIcon;
			this.whatsappIcon = this.$route.meta.showWhatsappIcon;
			this.favoritesIcon = this.$route.meta.showFavoritesIcon;
			this.mgChat = this.$route.meta.aiChat;
			this.escapeRoute = this.$route.meta.escapeRoute;
			if (this.escapeRoute == null || this.escapeRoute == undefined) {
				this.escapeRoute = this.$route.query.escapeRoute;
			}
			this.allowBack = this.$route.meta.allowBack ?? true;
			this.addButton = this.$route.meta.addButton ?? false;
			this.notificationsIcon = this.$route.meta.showNotifications ?? false;
		},
		goEscape() {
			if (this.escapeRoute == '<') this.$router.go(-1);
			else
				this.$router.push({ path: '/' + this.escapeRoute, replace: true });
		},
		onEditPressed() {
			this.$emit('edit');
			if (this.edit && typeof this.edit === 'string') {
				this.$router.push(this.edit);
			}
		},
		handleBack() {
			if (this.$route.meta.overrideBack) {
				this.$router.push(this.$route.meta.overrideBack);
			}
			else
			{
				this.$router.back();
			}
		},
		handleLogicalBack() {
			this.$emit('logicalBack');
		},
		handleDelete() {
			this.deleting = true;
			this.$emit('delete', () => {
				this.showDelete = false;
			});
		}
	},
	watch: {
		showDelete(newVal) {
			if (!newVal) {
				this.deleting = false;
			}
		}
	},
	mounted: function () { this.onLoad(); }
}
</script>

<style scoped>
.headerBlock {
	/* Header color variables */
	--header-text-color: #413655;
	--header-bg-color: #F9F7F3;
	--header-border-color: rgba(65, 54, 85, 0.1);

	height: 56px;
	padding-top: 4px;
	border-bottom: 1px solid var(--border-color);
	margin-bottom: 20px;
	margin-left: -30px;
	margin-right: -30px;

	position: sticky;
	top: 0;
	width: 100vw;
	z-index: 100;
	/* background-color: var(--background-color-alt); */
}

.title {
	font-size: 15px;
	line-height: 22px;
	letter-spacing: 0px;
	font-family: Gotham-Heavy;
	color: var(--header-text-color);
	text-align: center;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.right-col {
	text-align: right;
}

.right-col-icons {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 12px;
	flex-wrap: nowrap;
}

.right-col-icons.single-icon .mg-circle-image-button,
.right-col-icons.single-icon .mg-circle-icon-button,
.right-col-icons.single-icon .mg-chat-button {
	height: 24px !important;
	width: 24px !important;
}

.right-col-icons.single-icon .favorites-icon {
	height: 24px !important;
	width: 24px !important;
	object-fit: contain;
}

@media (max-width: 400px) {
	.right-col-icons {
		gap: 12px;
	}

	.mg-circle-image-button,
	.mg-circle-icon-button,
	.mg-chat-button {
		height: 24px !important;
		width: 24px !important;
	}

	.menu-button {
		height: 24px !important;
		width: 24px !important;
	}
}

@media (max-width: 600px) and (min-width: 401px) {
	.right-col-icons {
		gap: 12px;
	}

	.mg-circle-image-button,
	.mg-circle-icon-button,
	.mg-chat-button {
		height: 24px !important;
		width: 24px !important;
	}
}

.mg-circle-image-button,
.mg-circle-icon-button,
.mg-chat-button,
.menu-button {
	flex-shrink: 0;
}

.mg-circle-icon-button {
	/* background-color: var(--text-color); */
	border-radius: 50% !important;
	height: 24px !important;
	width: 24px !important;
	text-align: center;
	margin-top: 0;
	display: flex;
	align-items: center;
	justify-content: center;
}

.back-arrow-icon {
	width: 24px;
	height: 24px;
	display: block;
	margin: 0 auto;
}

.white-arrow {
	filter: brightness(0) invert(1);
}

.close-icon {
	width: 24px;
	height: 24px;
}

.menu-icon {
	width: 24px;
	height: 24px;
}

:root.dark-mode .back-arrow-icon {
	filter: brightness(0) invert(1);
}

.mg-circle-image-button {
	/* background-color: var(--text-color); */
	border-radius: 50% !important;
	height: 24px !important;
	width: 24px !important;
	text-align: center;
	margin-top: 0;
	background-position: center;
}

.notification-bell-wrapper {
	position: relative;
	flex-shrink: 0;
	display: flex;
	align-items: center;
}

.notification-badge {
	position: absolute;
	top: -8px;
	right: -8px;
	background-color: var(--text-color);
	color: white;
	font-size: 8px;
	font-weight: bold;
	width: 20px;
	height: 20px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	line-height: 1;
}

.favorites-icon {
	height: 20px !important;
	width: 20px !important;
	object-fit: contain;
}

.mg-chat-button {
	border-radius: 50% !important;
	height: 24px !important;
	width: 24px !important;
	margin-top: 0;
}

.menu-button {
	height: 24px !important;
	width: 24px !important;
	margin-top: 0;
}

.menu-button :deep(.v-icon) {
	font-size: 20px;
}

.menu-button:hover {
	opacity: 1;
}

/* Hide menu button when drawer is open */
.v-navigation-drawer--active+.menu-button {
	display: none;
}

/* Dark mode */
.headerBlock.dark {
	background-color: var(--dark-bg-primary);
	border-bottom-color: var(--dark-border);
}

.headerBlock.dark .title {
	color: var(--dark-text-primary);
}

.headerBlock.dark .back-arrow-icon {
	filter: brightness(0) invert(1);
}

/* Light mode */
.headerBlock.light {
	background-color: var(--background-color-main);
	border-bottom-color: var(--border-color);
}

.headerBlock.light .title {
	color: var(--text-color);
}
</style>